import React from 'react';

const AuthorizedUserContext = React.createContext(false);

export default AuthorizedUserContext;
